import * as React from 'react';

import { HttpTransportType, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

import useProgressProvider from './ProgressProvider';
import useThemeProvider from './ThemeProvider';
import { useTranslation } from 'react-i18next';

const SessionContext = React.createContext<any>({});

export const SessionProvider = ({ children }) => {
    const [name, setName] = React.useState('');
    const [location, setLocation] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [purpose, setPurpose] = React.useState('');
    const [domain, setDomain] = React.useState('');
    const [sessionId, setSessionId] = React.useState(-1);
    const [status, setStatus] = React.useState('Created');
    const [total_question, setTotalQuestion] = React.useState();
    const [thankyouMessage, setThankyouMessage] = React.useState('');
    const [thankyouPath, setThankyouPath] = React.useState('');
    const [logoPath, setLogoPath] = React.useState('');
    const [botIconPath, setBotIcon] = React.useState('');
    const [showSkip, setShowSkip] = React.useState(false);
    const [showUndo, setshowUndo] = React.useState(false);
    const [client, setClient] = React.useState('');
    const [initiate, setInitiate] = React.useState(false);
    const [survey, setSurvey] = React.useState({});
    const [user, setUser] = React.useState({});
    const [channel, setChannel] = React.useState('');
    const { i18n } = useTranslation();
    const { setShowProgress } = useProgressProvider();
    const { setTheme } = useThemeProvider();
    const [connection, setConnection] = React.useState(null);

    React.useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_API_STATIC_URL}hubs/session`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
                logger: LogLevel.Information
            })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    React.useEffect(() => {
        if (connection && sessionId && sessionId !== -1) {
            connection
                .start()
                .then((result) => {
                    console.log('Connected!', result);
                    connection
                        .invoke('JoinSession', sessionId)
                        .then((res) => {
                            console.log({ res });
                        })
                        .catch((err) => {
                            console.log({ err });
                        });
                })
                .catch((e) => console.log('Connection failed: ', e));
        }
    }, [connection, sessionId]);

    const SetUp = (session_id, res) => {
        setSessionId(session_id);
        setName(res?.session?.name);
        setLocation(res?.session?.location);
        setPurpose(res?.session?.purpose);
        setDomain(res?.session?.domain);
        setEmail(res?.session?.email);
        setThankyouPath(res?.survey?.thankyouPage?.banner);
        if (res?.survey?.logo) {
            setLogoPath(res?.survey?.logo);
        } else {
            setLogoPath(res?.session?.logoPath);
        }
        if (res?.survey?.botIcon) {
            setBotIcon(res?.survey?.botIcon);
        } else {
            setBotIcon(res?.session?.logoPath);
        }
        if (res?.survey) {
            setShowProgress(res?.survey?.useProgress);
        } else {
            setShowProgress(true);
        }
        if (res?.survey) {
            setSurvey(res?.survey);
        }
        // setLogoPath(res?.session?.logoPath);
        setClient(res?.session?.client);
        i18n.changeLanguage(res?.session?.customer_language || 'en');
        if (res?.survey?.customTheme && res?.survey?.theme) {
            setTheme(res?.survey?.theme);
        } else {
            // setTheme(theme['defaultTheme']);
        }
        setStatus(res?.status);
        setTotalQuestion(res?.total_questions);
        setShowSkip(res?.allow_skip_button);
        setshowUndo(res?.showUndo);
        if (res?.survey_completed === true && res?.survey?.thankyouPage[res?.session?.customer_language]) {
            setThankyouMessage(res?.survey?.thankyouPage[res?.session?.customer_language][0]);
        }
        let user = {};
        if (res && res.session_details && res.session_details.length > 0) {
            res.session_details.forEach((detail) => {
                user[detail.key.toLowerCase()] = detail.value;
            });

            setUser(user);
        }
        return { user };
    };

    return (
        <SessionContext.Provider
            value={{
                name,
                setName,
                location,
                setLocation,
                thankyouPath,
                setThankyouPath,
                purpose,
                setPurpose,
                domain,
                SetUp,
                setDomain,
                status,
                setStatus,
                sessionId,
                setSessionId,
                thankyouMessage,
                setThankyouMessage,
                showSkip,
                setShowSkip,
                showUndo,
                setshowUndo,
                client,
                setClient,
                logoPath,
                setLogoPath,
                initiate,
                setInitiate,
                setSurvey,
                survey,
                botIconPath,
                setBotIcon,
                email,
                setEmail,
                user,
                setUser,
                connection,
                channel,
                setChannel,
                total_question
            }}>
            {children}
        </SessionContext.Provider>
    );
};
const useSessionProvider = () => {
    return React.useContext(SessionContext);
};

export default useSessionProvider;
